export default __webpack_public_path__ + "static/andre-staltz-41e10a87897b21969dd8cc5ff7ccc24a.jpg";